var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: _vm.titulo, width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.bytes
            ? _c("app-pdf-viewer", { attrs: { bytes: _vm.bytes } })
            : _vm._e()
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c("el-button", { on: { click: _vm.downloadPdf } }, [
              _c("i", { staticClass: "fal fa-file-pdf" }),
              _c("span", [_vm._v("  Exportar PDF")])
            ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e7a5150", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e7a5150","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gp/components/portaria/VisualizarPortaria.vue
// module id = null
// module chunks = 